import React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';

// Typography
import { Body3 } from '../../themes/typography';

export default function CustomSlotInput({
    error = false,
    required = false,
    onChange = () => {},
    onBlur = () => {},
    // placeholder = 'Enter custom duration',
    helperText = '',
    id = '',
    value = '30',
    name = '',
    label = 'Custom Duration',
    isHourSelected,
    setIsHourSelected,
    disabled
}) {
    // const [isHourSelected, setIsHourSelected] = useState('');

    const minuteSelected = isHourSelected === 'minutes' ? 'selected-unit' : '';
    const hourSelected = isHourSelected === 'hour' ? 'selected-unit' : '';

    function handleInputChange(e) {
        const newValue = e.target.value;
        // Only call parent's onChange if newValue contains only digits
        if (/^\d*$/.test(newValue)) {
            onChange(e);
        }
    }

    return (
        <FormControl>
            <InputLabel sx={{ color: '#f5f5f5 !important' }}>{label}</InputLabel>
            <OutlinedInput
                id={id}
                name={name}
                label={label}
                type="text"
                error={error}
                // value={`${value} ${isHourSelected}`}
                value={value}
                required={required}
                disabled={disabled}
                onChange={handleInputChange}
                onBlur={onBlur}
                sx={{
                    borderRadius: '15px',
                    fontFamily: 'Nunito, sans-serif',
                    color: '#f5f5f5',
                    width: '230px',
                    maxWidth: '100%',
                    fontSize: '1.125rem',
                    '& fieldset': {
                        borderColor: '#f5f5f5'
                    },
                    '&:hover fieldset': {
                        borderColor: '#F8A21E !important'
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#F8A21E !important'
                    },
                    '&.Mui-disabled': {
                        '&:hover fieldset': {
                            borderColor: '#f5f5f5 !important'
                        }
                    }
                }}
                endAdornment={
                    <InputAdornment position="end" sx={{ gap: '0.5rem' }}>
                        <div
                            className={`time-unit-container ${hourSelected}`}
                            onClick={() => setIsHourSelected('hour')}
                        >
                            <Body3>Hr.</Body3>
                        </div>
                        <div
                            className={`time-unit-container ${minuteSelected}`}
                            onClick={() => setIsHourSelected('minutes')}
                        >
                            <Body3>Min.</Body3>
                        </div>
                    </InputAdornment>
                }
            />
            <FormHelperText
                error={error}
                sx={{
                    color: '#f5f5f5',
                    margin: '6px 0px 0px 3px',
                    fontFamily: 'Nunito, sans-serif',
                    fontSize: '0.875rem',
                    lineHeight: 'none',
                    letterSpacing: '0px',
                    '&.Mui-error': {
                        color: '#f44336 !important'
                    }
                }}
            >
                {helperText}
            </FormHelperText>
        </FormControl>
    );
}
